import { render, staticRenderFns } from "./batchImportChargeAllBusiness.vue?vue&type=template&id=20ed24ca&scoped=true&"
import script from "./batchImportChargeAllBusiness.vue?vue&type=script&lang=js&"
export * from "./batchImportChargeAllBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ed24ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ed24ca')) {
      api.createRecord('20ed24ca', component.options)
    } else {
      api.reload('20ed24ca', component.options)
    }
    module.hot.accept("./batchImportChargeAllBusiness.vue?vue&type=template&id=20ed24ca&scoped=true&", function () {
      api.rerender('20ed24ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/ImportChargeAllBusiness/importCharge/batchImportChargeAllBusiness.vue"
export default component.exports